import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdcc0442"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-title" }, "Image", -1))
const _hoisted_3 = { class: "upload-view-image-section" }
const _hoisted_4 = { class: "picture-icon-container" }
const _hoisted_5 = {
  key: 0,
  class: "displayed-image"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "far fa-newspaper awaiting-news-image"
}
const _hoisted_8 = { class: "upload-button-disclaimer-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "picture-disclaimer" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Note: Please ensure you have the rights to use any pictures so that the pictures are copyright free. Failure to do so could result in the owner taking action against unauthorised use.")
], -1))

import { computed, ref, inject, watch } from "vue";
import modalBase from "@/components/ui/modals/modal-base.vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { DxToolbarItem } from "devextreme-vue/popup";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { ValidatedEvent } from "devextreme/ui/validator";
import SwitchToggle from "../ui/toggles/switch-toggle.vue";
import AcquaintDateBox from "@/components/ui/inputs/acquaint-date-box.vue";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import { NewsValidation } from "acquaint-api/validation/NewsValidation";
import { News } from "acquaint-api/models/News";
import AcquaintTextArea from "../ui/inputs/acquaint-text-area.vue";
import FileUpload from "../ui/inputs/file-upload.vue";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { WebsiteNewsRecordImage } from "@/types/marketing/WebsiteNewsRecordImage";
import {
  getFileNameParts,
  convertCorrespondenceFileToBlob,
} from "@/utils/files/CorrespondenceFileConverter";


export default /*#__PURE__*/_defineComponent({
  __name: 'new-edit-news-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the template.
   * @type {number}
   * @required
   */
  configurationId: {
    type: Number,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * This is used to update the v-model variable in the parent component and control the visibility of the modal.
   * @event update:modelValue
   * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
   */
  "update:modelValue",

  /**
   * Triggered when an existing configuration item is edited.
   * This notifies the parent component that an item has been modified.
   * @event configurationItemEdited
   * @property {boolean} inActive - Indicates whether the configuration item is inactive.
   */
  "configurationItemEdited",

  /**
   * Triggered when a new configuration item is created.
   * This notifies the parent component that a new item has been added.
   * @event configurationItemCreated
   */
  "configurationItemCreated",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: Boolean) => emit("update:modelValue", value),
});

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const acquaintApiNextClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;

const itemData = ref<News>();
const lockedByAnotherUser = ref(false);
const keepingModalOpening = ref(false);
const submissionResponse = ref<News>();
const resetImageField = ref(false);
const imageToUpload = ref<File>();
const uploadedPictureURL = ref("");
const recordImage = ref<WebsiteNewsRecordImage>();

const lockConfigurationItem = async () => {
  try {
    await acquaintApiClient.httpPostVoid(
      `database/news/${props.configurationId}/lock`,
      { lock: true, extraInfo: "" },
    );
  } catch (err) {
    lockedByAnotherUser.value = true;
    displayErrorMessage(
      "These details are already being edited by another user.",
    );
  }
};

const unLockConfigurationItem = async () => {
  try {
    await acquaintApiClient.httpPostVoid(
      `database/news/${props.configurationId}/lock`,
      { lock: false, extraInfo: "" },
    );
  } catch (err) {
    displayErrorMessage("We were unable to unlock these details.");
  }
};

const fetchItemData = async () => {
  try {
    if (props.configurationId == 0) {
      itemData.value = await acquaintApiClient.httpGet<News>(
        `database/news/defaultmodel`,
      );
    } else {
      itemData.value = await acquaintApiClient.httpGet<News>(
        `database/news/${props.configurationId}`,
      );
    }
  } catch (err) {
    itemData.value = undefined;
    if (props.configurationId == 0) {
      displayErrorMessage("The selected details could not be fetched");
    } else {
      displayErrorMessage("We could not fetch the default data");
    }
  }
};

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value || keepingModalOpening.value) {
      return;
    }

    lockedByAnotherUser.value = false;
    resetImageField.value = true;

    setTimeout(() => {
      resetImageField.value = false;
    }, 100);
    uploadedPictureURL.value = "";
    imageToUpload.value = undefined;

    await fetchItemData();

    if (props.configurationId == 0) {
      return;
    }

    await fetchDisplayImage();

    await lockConfigurationItem();
  },
);

const fetchImage = async () => {
  try {
    recordImage.value = await acquaintApiNextClient.httpGet(
      `News/${props.configurationId}/Image`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    recordImage.value = undefined;
  }
};

const fetchDisplayImage = async () => {
  await fetchImage();

  if (!recordImage.value || !recordImage.value.image) {
    uploadedPictureURL.value = "";
    return;
  }

  const fileName = getFileNameParts(recordImage.value.image.fileDownloadName);
  if (fileName) {
    imageToUpload.value = new File(
      [convertCorrespondenceFileToBlob(recordImage.value.image)],
      fileName.nameWithExtension,
      { type: recordImage.value.image.contentType },
    );
    uploadedPictureURL.value = window.URL.createObjectURL(imageToUpload.value);
  }
};

const saveDetails = async (e: any) => {
  const validation: ValidatedEvent = e.validationGroup.validate();
  // Don't continue if user has entered invalid data
  if (!validation.isValid) {
    return;
  }

  if (!(await callSaveApi())) {
    return;
  }

  if (imageToUpload.value) {
    await uploadImage();
  }

  lockedByAnotherUser.value = true;

  if (props.configurationId > 0) {
    await unLockConfigurationItem();
    emit("configurationItemEdited", itemData.value?.inActive);
  } else {
    emit("configurationItemCreated");
  }

  showModal.value = false;
};

const uploadImage = async () => {
  try {
    await acquaintApiClient.uploadFile(
      `app/marketing/news/${submissionResponse.value?.id}/picture`,
      imageToUpload.value,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const callSaveApi = async () => {
  try {
    if (props.configurationId == 0) {
      submissionResponse.value = await acquaintApiClient.httpPost<News>(
        `database/news`,
        itemData.value,
      );
    } else {
      submissionResponse.value = await acquaintApiClient.httpPut<News>(
        `database/news/${props.configurationId}`,
        itemData.value,
      );
    }
    return true;
  } catch (err) {
    if (props.configurationId == 0) {
      displayErrorMessage("A new system item could not be created.");
    } else {
      displayErrorMessage("The selected details could not be edited.");
    }
    return false;
  }
};
const cancelClick = () => {
  showModal.value = false;
};

const keepEnteredInformation = () => {
  keepingModalOpening.value = true;
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const modalClosed = async () => {
  if (props.configurationId > 0) {
    await unLockConfigurationItem();
  }
  keepingModalOpening.value = false;
};

const imageAddedOrUpdated = (e: File[]) => {
  if (!e || e.length == 0) {
    imageToUpload.value = undefined;
    uploadedPictureURL.value = "";
    return;
  }

  imageToUpload.value = e[0];
  uploadedPictureURL.value = window.URL.createObjectURL(e[0]);
};

const maxDate = new Date();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(modalBase, {
    title: "News",
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showModal).value = $event)),
    showCloseButton: true,
    showCloseConfirmationPrompt: !lockedByAnotherUser.value,
    height: "650px",
    onCancelConfirmationModal: keepEnteredInformation,
    onModalClosed: modalClosed,
    width: _unref(ModalWidth).Small,
    onCancelPromptDenied: cancelPromptDenied
  }, {
    content: _withCtx(() => [
      (itemData.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createVNode(AcquaintTextbox, {
              fieldValidation: _unref(NewsValidation).Subject,
              label: "Subject",
              modelValue: itemData.value.subject,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((itemData.value.subject) = $event)),
              readOnly: lockedByAnotherUser.value,
              validationGroup: "NewsValidationGroup"
            }, null, 8, ["fieldValidation", "modelValue", "readOnly"]),
            _createVNode(AcquaintDateBox, {
              fieldValidation: _unref(NewsValidation).NewsDate,
              label: "Date",
              modelValue: itemData.value.newsDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((itemData.value.newsDate) = $event)),
              readOnly: lockedByAnotherUser.value,
              validationGroup: "NewsValidationGroup",
              "max-date": _unref(maxDate)
            }, null, 8, ["fieldValidation", "modelValue", "readOnly", "max-date"]),
            _createVNode(AcquaintTextArea, {
              fieldValidation: _unref(NewsValidation).Body,
              label: "Body",
              modelValue: itemData.value.body,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((itemData.value.body) = $event)),
              readOnly: lockedByAnotherUser.value,
              validationGroup: "NewsValidationGroup"
            }, null, 8, ["fieldValidation", "modelValue", "readOnly"]),
            _hoisted_2,
            _createElementVNode("section", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (uploadedPictureURL.value != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("img", { src: uploadedPictureURL.value }, null, 8, _hoisted_6)
                    ]))
                  : (_openBlock(), _createElementBlock("i", _hoisted_7))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(FileUpload, {
                  fileTypes: ".jpg",
                  reset: resetImageField.value,
                  multiple: false,
                  onFilesChanged: imageAddedOrUpdated,
                  "read-only": lockedByAnotherUser.value,
                  "show-file-list": true,
                  defaultFiles: imageToUpload.value ? [imageToUpload.value] : []
                }, null, 8, ["reset", "read-only", "defaultFiles"]),
                _hoisted_9
              ])
            ]),
            _createVNode(SwitchToggle, {
              label: "Inactive",
              labelWidth: "7.5rem",
              modelValue: itemData.value.inActive,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((itemData.value.inActive) = $event)),
              readOnly: lockedByAnotherUser.value
            }, null, 8, ["modelValue", "readOnly"])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Save',
          disabled: lockedByAnotherUser.value,
          onClick: (e) => {
            saveDetails(e);
          },
          validationGroup: 'NewsValidationGroup',
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            cancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "showCloseConfirmationPrompt", "width"]))
}
}

})